import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import { ApiService } from '../_services/api.service';
import { LocalizeRouterService } from 'localize-router';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class HomepageResolver implements Resolve<any> {

  constructor(private apiService: ApiService, private localize: LocalizeRouterService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cdLingua = this.localize.parser.currentLang.toUpperCase();
    console.log( 'HomepageResolver -> ', this.localize.parser.currentLang );
    const anteprima = (route.queryParams.anteprima === 'true' ? true : false);
    const id = (route.queryParams.id ? route.queryParams.id : null);
    return this.apiService.getHomepage({cdLingua, anteprima, id}).pipe(tap(home => home.blocchi = home.blocchi.sort((b1, b2) => b1.ordine - b2.ordine)));
  }

}
